/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Kind_MetaInputs */



/**
* | output |
* | --- |
* | "Meta-League" |
*
* @param {League_Kind_MetaInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_kind_meta = /** @type {((inputs?: League_Kind_MetaInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Kind_MetaInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Méta-ligue")
	if (locale === "es") return /** @type {LocalizedString} */ ("Meta-Liga")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Meta-Liga")
	if (locale === "it") return /** @type {LocalizedString} */ ("Meta-Campionato")
	return /** @type {LocalizedString} */ ("Meta-League")
});